import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  JoinSquadMutation,
  JoinSquadMutationVariables,
} from './__generated__/useJoinSquad.graphql.ts';

const JOIN_SQUAD_MUTATION = gql`
  mutation JoinSquadMutation($input: joinSquadInput!, $sport: Sport!) {
    joinSquad(input: $input) {
      currentUser {
        slug
        squad(sport: $sport) {
          id
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<JoinSquadMutation, JoinSquadMutationVariables>;

type JoinSquadInput = { joinSecret: string } | { squadId: string };

type Options = {
  showErrorsInForm?: boolean;
};

export const useJoinSquad = ({ showErrorsInForm }: Options = {}) => {
  const { sport } = useSportContext();
  const [mutate, { loading }] = useMutation(JOIN_SQUAD_MUTATION, {
    showErrorsWithSnackNotification: !showErrorsInForm,
    showErrorsInForm,
  });

  const joinSquad = async (input: JoinSquadInput) => {
    return mutate({
      variables: { input, sport },
    });
  };

  return { joinSquad, loading };
};
